import React, { useState, useEffect } from "react";
import { CouponPageStyle } from "./Coupon.styled";
import TopBar from "../../components/TopBar/TopBar";
import AddCoupons from "../../components/Coupons/AddCoupons";
import ViewCoupons from "../../components/Coupons/ViewCoupons";
import Footer from "../../components/footer/Footer";
import { useDB } from "../../context/DynamoDBContext";
import { useReload } from "../../context/ReloadContext";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getCouponDownloadList, getCouponList } from "../../api/CouponApi";
import { downloadCouponReports } from "../../common/DownloadCoupons";
import { getMonthString } from "../../common/ConvertMonth";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { getSubscriptionString } from "../../common/ConvertSubscription";
import { toast } from "react-toastify";
import { MainBodyStyle } from "../../styles/MainBodyStyles";

const Coupon = () => {
  const { dynamoDBClient } = useDB();
  const { reload } = useReload();
  const queryClient = useQueryClient();
  const [promoGroups, setPromoGroups] = useState([]);
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [couponListApiEnable, setCouponListApiEnable] = useState(false);
  const [couponTableStatus, setCouponTableStatus] = useState("Loading ...");
  const [viewPromo, setViewPromo] = useState({});
  const [promoGroupId, setPromoGroupId] = useState("");
  const [promoGroupName, setPromoGroupName] = useState("");
  const [enableApi, setEnableApi] = useState(false);
  const [disableExport, setDisableExport] = useState(false);
  const [downloadList, setDownloadList] = useState([]);
  const [check, setCheck] = useState(false);
  const [nextPage, setNextPage] = useState({ Code: "" });

  useEffect(() => {
    if (dynamoDBClient) {
      setCouponListApiEnable(true);
    } else {
      setCouponListApiEnable(false);
    }
  }, [dynamoDBClient]);

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["getCouponList"]);
    }
  }, [reload]);

  const handleError = (type) => {
    if (type === "getCouponList") {
      toast.error("Error while loading Promo Codes", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const { data: couponList, status: recordStatus } = useQuery({
    queryKey: ["getCouponList"],
    queryFn: () => getCouponList(dynamoDBClient),
    enabled: couponListApiEnable,
    onSuccess: (data) => {
      if (data.length === 0) {
        setCouponTableStatus("No Promotional Groups Available");
      } else {
        setPromoGroups(data);
      }
      setCouponListApiEnable(false);
    },
    onError: (error) => {
      console.log("getCouponList :", error);
      handleError("getCouponList");
    },
  });

  const { status: couponlistStatus, data: couponlistData } = useQuery({
    queryKey: ["downloadPromoCodes", promoGroupId],
    queryFn: () =>
      getCouponDownloadList(dynamoDBClient, promoGroupId, nextPage),
    enabled: enableApi,
    onSuccess: (data = []) => {
      const arr = data.Items;
      const nextPagetoLoad = data?.LastEvaluatedKey;

      if (nextPagetoLoad) {
        setNextPage(nextPagetoLoad);
        setCheck(true);
        const compareCheck = nextPagetoLoad?.Code === nextPage?.Code;

        if (!compareCheck) {
          const result = [...downloadList, ...arr];
          setDownloadList(result);

          queryClient.fetchQuery(["downloadPromoCodes", promoGroupId]);
        } else {
          queryClient.fetchQuery(["downloadPromoCodes", promoGroupId]);
        }
      } else {
        if (check) {
          downloadCouponReports(
            {
              PromoGroupName: promoGroupName,
              children: [...downloadList, ...arr],
            },
            false
          );
        } else {
          downloadCouponReports(
            {
              PromoGroupName: promoGroupName,
              children: data,
            },
            false
          );
        }
        setDownloadList([]);
        setNextPage({ Code: "" });
        setEnableApi(false);
        setPromoGroupId("");
        setPromoGroupName("");
        setDisableExport(false);
      }
    },
  });

  if (couponlistStatus === "error") {
    setEnableApi(false);
    setPromoGroupId("");
    setPromoGroupName("");
    setDisableExport(false);
  }

  return (
    <CouponPageStyle>
      <AddCoupons
        visible={modal1}
        setVisible={(check) => {
          if (check) {
            queryClient.fetchQuery(["getCouponList"]);
          }
          setModal1(false);
        }}
      />
      <ViewCoupons
        visible={modal2}
        setVisible={() => setModal2(false)}
        promoGroup={viewPromo}
      />
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>Promotional Groups</HeadingStyle>
        <div className="btn-div">
          <button
            className="btn form-button"
            onClick={() => {
              setModal1(true);
            }}
          >
            Create Promotional Group
          </button>
        </div>
        <div className="table-container">
          <div className="table-div">
            <table className="table table-hover">
              <thead className="table-head">
                <tr>
                  <th scope="col" className="table-item">
                    #
                  </th>
                  <th scope="col" className="table-item">
                    Promotional Groups
                  </th>
                  <th scope="col" className="table-item">
                    Subscription Id
                  </th>
                  <th scope="col" className="table-item">
                    Codes Redeemed
                  </th>
                  <th scope="col" className="table-item">
                    Duration
                  </th>
                  <th scope="col" className="table-item">
                    Status
                  </th>
                  <th scope="col" className="table-item">
                    Export
                  </th>
                  <th scope="col" className="table-item">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {recordStatus === "loading" || reload ? (
                  <tr>
                    <td colSpan={8}>
                      <p className="table-loading">Loading...</p>
                    </td>
                  </tr>
                ) : promoGroups.length === 0 ? (
                  <tr>
                    <td colSpan={8}>
                      <p className="table-loading">{couponTableStatus}</p>
                    </td>
                  </tr>
                ) : (
                  promoGroups.map((item, index) => (
                    <tr key={index}>
                      <th scope="row" className="table-item">
                        {index + 1}
                      </th>
                      <td className="table-item2">{item.PromoGroupName}</td>
                      <td className="table-item2">
                        {getSubscriptionString(item?.SubscriptionId)}
                      </td>
                      <td className="table-item2">
                        {item.activePromos} / {item.NumberOfPromos}
                      </td>
                      <td className="table-item2">
                        {getMonthString(item.Duration)}
                      </td>
                      <td className="table-item2">{item.status}</td>
                      <td>
                        <i
                          className={
                            disableExport
                              ? "bi bi-download export-icon-style disable-icon"
                              : "bi bi-download export-icon-style"
                          }
                          onClick={() => {
                            setPromoGroupId(item.PromoGroupId);
                            setPromoGroupName(item.PromoGroupName);
                            setEnableApi(true);
                            setDisableExport(true);
                          }}
                        ></i>
                      </td>
                      <td>
                        <div className="action-items">
                          <i
                            title="View"
                            className={"bi bi-eye view-icon"}
                            onClick={() => {
                              setViewPromo(item);
                              setModal2(true);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </CouponPageStyle>
  );
};

export default Coupon;
